import { deepMerge } from '@tunasong/models'
import type { AIConfig } from '../schema/ai-schema.js'

/**
 * Merge custom AI config with user AI config.
 * Custom (e.g. band) config takes precedence over user config.
 * Returns a merged AIConfig or undefined if neither is set.
 */
export const mergeAiConfigs = (customConfig?: AIConfig, userConfig?: AIConfig): AIConfig | undefined => {
  if (!customConfig && !userConfig) {
    return undefined
  }
  if (!customConfig) {
    return userConfig
  }
  if (!userConfig) {
    return customConfig
  }
  return deepMerge({} as AIConfig, userConfig, customConfig)
}
